import styles from './Header.module.css';
import UserPanel from './UserPanel';
import CompanyLogo from '../Sidebar/CompanyLogo';

function Header() {

  return (
    <header className={styles.content}>
      <CompanyLogo />
      <UserPanel />
    </header>
  );
}

export default Header;
